import axios from '@/service/axios';
const CORP_API = '/api/corp';
export const corpApi = {
  signUpApi(email, password, corpNm, marketing, encryptString, sessionKey) {
    return axios.post(`${CORP_API}/v3/singIn`, {
      email,
      password,
      corpNm,
      marketing,
      encryptString,
      sessionKey,
    });
  },
  updateCorpApi(corpId, encryptString, sessionKey) {
    return axios.post(`${CORP_API}/v3/updateCorp`, { corpId, encryptString, sessionKey });
  },
  getAuthEmail(toMail) {
    return axios.post(`${CORP_API}/getAuthEmail`, { toMail });
  },
};
